import {
  USAGE_REPORT_REQUEST,
  USAGE_REPORT_FAILED,
  USAGE_REPORT_SUCCESS
} from "../Actions/ReportsActions";

const initialState = { 
  loading: false,
  success: false,
  usageReportData:[],
};

export const ReportsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case USAGE_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USAGE_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        usageReportData:action?.payload, 
      };
    case USAGE_REPORT_FAILED:
        return {
          ...state,
          loading: false,
          success: false,
        }; 
    default:
      return state;
  }
};
